import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'
import styles from './Blockquote.module.scss'

export const Blockquote: FunctionComponent<Props> = ({
  caption,
  className,
  quotes = false,
  text,
  ...rest
}) => {
  return (
    <figure
      data-testid="blockquote"
      className={classnames(styles.figure, className)}
      {...rest}
    >
      <blockquote
        className={classnames(styles.blockquote, {
          [styles.blockquoteIncludeQuotes]: quotes,
        })}
      >
        <TypographyV2 textStyle="sb-text-heading-large">{text}</TypographyV2>
      </blockquote>
      {caption && (
        <figcaption className={styles.figcaption}>
          <TypographyV2 textStyle="sb-text-interface-body-small-regular">
            {caption}
          </TypographyV2>
        </figcaption>
      )}
    </figure>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * String of text that will be displayed as the quote.
   */
  text: string
  /**
   * String of text that will be displayed below the quote as a caption.
   */
  caption?: string
  /**
   * Boolean that determines whether the quote text is wrapped in Roman hanging punctuation marks.
   */
  quotes?: boolean
  /**
   * Optional class name for additional styling.
   */
  className?: string
} & ComponentPropsWithoutRef<'figure'>
